module.exports = __webpack_public_path__ + "static/img/qq_4.b462fa49.png";